<template>
  <footer class="footer">
    <a href="https://twitter.com/evangelinepapan"
      ><i class="fab fa-twitter-square"></i
    ></a>
    <a href="https://www.instagram.com/evangelinepapanicola/"
      ><i class="fab fa-instagram"></i
    ></a>
    <a href="https://www.linkedin.com/in/evangelinepapanicola/"
      ><i class="fab fa-linkedin"></i
    ></a>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>
